import React, {useState, useEffect, useRef} from "react"
import styled from "styled-components"
import {Select} from "@irati/ui/src/FormItem"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import loadCompanyValues from "@irati/companyvalues/apollo/query/LoadCompanyValues"
import {CompanyValue} from "@irati/companyvalues/types"
import TrophyImg from "@irati/ui/src/Trophy"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import mainTheme from "@irati/ui/src/global/theme"
import ToggleButton from "@irati-web/recognition/src/components/shared/ToggleButton"
import {StyledTrophyWrapper} from "./styled"

const defaultProps = {
  defaultOptions: true,
  labelKey: "tag",
  isMulti: true,
  placeholder: "platform.fields.companyValue.placeholder",
  stringlength: "platform.fields.companyValue.noneFound",
  underLimit: "platform.fields.companyValue.underCharLimit",
  valueKey: "uuid"
}
const StyledFlex = styled(Flex)`
  .form-group {
    margin: 0;
  }
  .col-xs-12 {
    padding: 0;
  }
`
interface Props extends InjectIntl {
  defaultOptions?: boolean
  label?: string
  labelKey?: string
  isMulti?: boolean
  onChange(companyValues: CompanyValue[]): void
  placeholder?: string
  stringlength?: string
  underLimit?: string
  valueKey?: string
  companyValues?: CompanyValue[]
}

const SelectCompanyValue: React.FC<Props> = (props) => {
  const {formatMessage, isMulti, companyValues, onChange} = props
  const [options, setOptions] = useState<CompanyValue[]>([])
  const selectRef = useRef<HTMLDivElement>(null)
  const [maxWidth, setMaxWidth] = useState(0)
  useEffect(() => {
    const params = {
      limit: 9999,
      tenantId: authentication.business().uuid
    }

    loadCompanyValues(params).then(({results}) => {
      setOptions(results)
    })
  }, [])

  const onOptionSelected = (items: CompanyValue[]) => {
    onChange(items)
  }
  const value = options.filter((option) => companyValues?.some(({uuid}) => uuid === option.uuid))

  const onMenuOpen = () => {
    if (!selectRef?.current?.getBoundingClientRect()) {
      return
    }
    const newMaxWidth = window.screen.availWidth - selectRef.current.getBoundingClientRect().left - 16
    setMaxWidth(newMaxWidth)
  }
  return (
    <StyledFlex alignItems="center" ref={selectRef}>
      <Select
        {...props}
        value={value}
        autoComplete={false}
        id="company-values"
        isMulti={isMulti}
        isClearable={false}
        flush
        options={options}
        onMenuOpen={onMenuOpen}
        hideLabel
        styles={{
          menu: (baseStyles) => ({
            ...baseStyles,
            width: "max-content",
            maxWidth: `${maxWidth}px`
          })
        }}
        onChange={onOptionSelected}
        controlShouldRenderValue={false}
        components={{
          OptionIcon: ({icon}: CompanyValue) => {
            return icon ? (
              <StyledTrophyWrapper>
                <TrophyImg isSet size="30px" src={icon.href} />
              </StyledTrophyWrapper>
            ) : null
          },
          DropdownIndicator: () => null,
          Placeholder: () => null,
          ValueContainer: ({children}) => children,
          Control: (controlProps) => <div onClick={(event) => controlProps.innerProps.onMouseDown(event)}>{controlProps.children}</div>,
          Input: (inputProps) => (
            <ToggleButton {...inputProps} active={inputProps.selectProps!.menuIsOpen}>
              <Icon icon={IconTypes.plus} size={10} marginRight={mainTheme.spacing.half} />
              {formatMessage({id: "platform.recognition.popup.createRecognition.addCompanyValues.cta"})}
            </ToggleButton>
          )
        }}
      />
    </StyledFlex>
  )
}
SelectCompanyValue.defaultProps = defaultProps

export default injectIntl(SelectCompanyValue)
